var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoCkBirla(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 349.733,
    height: 45.738,
    viewBox: "0 0 349.733 45.738",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21",
    d: "M21.611 45.9c-1.169-.208-2.346-.385-3.508-.631A22.734 22.734 0 0 1 18.712.732c1.806-.362 3.68-.388 5.523-.569l.022.254A44.842 44.842 0 0 0 19.81 1.83C11.393 5.461 6.449 11.788 5.435 20.913a22.826 22.826 0 0 0 17.724 24.454 9.4 9.4 0 0 1 1.365.535z",
    transform: "translate(-.249 -.163)",
    style: {
      fill: "#ee3538"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22",
    d: "M125.458 24.825c.262.177.473.321.686.461a5.518 5.518 0 0 1 .171 9.4 7.676 7.676 0 0 1-4.46 1.421c-2.816.04-5.633.025-8.449.008a2.359 2.359 0 0 1-2.541-2.543q-.016-7.982 0-15.966a2.3 2.3 0 0 1 2.534-2.516c3.038.038 6.091-.04 9.109.239a5.112 5.112 0 0 1 4.907 4.456A5.032 5.032 0 0 1 126.166 24c-.221.27-.454.531-.709.829m-6.571 7.525c.84 0 1.68.021 2.519 0a2.548 2.548 0 1 0 .032-5.092c-1.743-.048-3.489 0-5.232-.019-.487 0-.709.168-.7.669a127.78 127.78 0 0 1 0 3.766c-.012.574.263.706.771.692.872-.024 1.744-.006 2.617-.006m-.692-13.62v.046a16.735 16.735 0 0 0-2.027.028.9.9 0 0 0-.627.594 41.636 41.636 0 0 0 0 3.756.814.814 0 0 0 .558.565 43.845 43.845 0 0 0 4.534-.108 2.18 2.18 0 0 0 2.06-2.363 2.32 2.32 0 0 0-2.088-2.376c-.792-.117-1.6-.1-2.407-.143",
    transform: "translate(-21.28 -3.001)",
    style: {
      fill: "#4b4b4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 23",
    d: "M164.233 27.92 169 36.112c-1.786 0-3.413.023-5.036-.027-.228-.006-.513-.334-.656-.58a334.104 334.104 0 0 1-3.591-6.3 1.194 1.194 0 0 0-1.224-.706c-1.447.038-2.9.012-4.461.012v7.542h-4.735V18.065c0-2.183.8-2.989 2.96-2.991 2.943 0 5.887-.008 8.83 0a6.68 6.68 0 0 1 6.763 4.745c.9 3.082-.26 5.929-3.173 7.779-.131.083-.254.181-.441.317m-10.172-2.984c2.061 0 4.022.011 5.983-.009a4.2 4.2 0 0 0 1.234-.2 3.037 3.037 0 0 0 2.043-3.065 2.638 2.638 0 0 0-2.187-2.7c-2.331-.156-4.68-.045-7.073-.045z",
    transform: "translate(-28.589 -2.999)",
    style: {
      fill: "#4b4b4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24",
    d: "M77.66 27.425v8.612h-4.6V15.152h4.526V23.3c.474-.4.737-.6.975-.825 2.413-2.294 4.81-4.6 7.248-6.87a2.107 2.107 0 0 1 1.259-.508c1.7-.057 3.405-.023 5.41-.023L81.643 25.257l11.292 10.852c-2.129 0-4.023.025-5.916-.026-.291-.008-.6-.33-.852-.564q-3.793-3.61-7.566-7.24c-.242-.232-.5-.451-.94-.854",
    transform: "translate(-14.093 -2.997)",
    style: {
      fill: "#4b4b4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25",
    d: "M263.612 25.762a10.658 10.658 0 1 1 21.316.062 10.658 10.658 0 1 1-21.316-.062m10.488 7.213c4.036.1 6.826-2.733 6.956-7.053.125-4.139-2.662-7.287-6.546-7.394-4-.111-6.922 2.747-7.03 6.889-.117 4.453 2.518 7.46 6.621 7.558",
    transform: "translate(-50.325 -3.002)",
    style: {
      fill: "#4b4b4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26",
    d: "M242.236 15.491v8.384c.41.021.752.052 1.093.053q3.882.006 7.766 0c1.24 0 1.242 0 1.243-1.283 0-2.064.031-4.128-.014-6.191-.017-.773.254-1.02 1.007-.978.927.053 1.86.014 2.852.014v20.633h-3.766c-.026-.351-.074-.721-.075-1.09q-.012-3.386 0-6.77c0-.5-.034-.873-.7-.867-2.977.025-5.953.015-8.93.023a2.683 2.683 0 0 0-.472.1v8.613h-3.907c-.017-.345-.046-.658-.047-.972 0-6.19.019-12.379-.024-18.568-.006-.918.279-1.181 1.15-1.118.893.064 1.8.014 2.829.014",
    transform: "translate(-45.505 -3.075)",
    style: {
      fill: "#4b4b4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27",
    d: "m197.818 36.069 3.124-7.557 4.947-11.966c.519-1.255 1.126-1.73 2.183-1.717 1.151.014 1.7.73 2.094 1.7q3.824 9.293 7.681 18.573c.12.29.208.594.338.965-1.416 0-2.742.03-4.063-.026a1.054 1.054 0 0 1-.716-.567c-.428-.972-.8-1.97-1.145-2.974a1.013 1.013 0 0 0-1.114-.813c-2.1.036-4.208.027-6.312 0a.893.893 0 0 0-.988.7c-.343 1.005-.765 1.983-1.118 2.985-.167.474-.367.732-.948.708-1.259-.054-2.521-.017-3.963-.017m10.224-14.742-2.536 6.842h5a5.109 5.109 0 0 0-.137-.6c-.735-1.984-1.475-3.965-2.326-6.247",
    transform: "translate(-37.815 -2.952)",
    style: {
      fill: "#4b4b4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28",
    d: "M319.52 28.664v7.47h-3.848c-.03-.372-.085-.742-.086-1.111q-.007-8.457 0-16.914c0-2.014.6-2.615 2.58-2.615 2.845 0 5.694-.067 8.535.04a6.464 6.464 0 0 1 5.819 9.04 6.243 6.243 0 0 1-5.848 4.062c-2 .1-4.009.025-6.013.028h-1.139m.028-3.422c2.358 0 4.646.124 6.911-.043a3.011 3.011 0 0 0 2.621-3.115 2.872 2.872 0 0 0-2.485-3.093c-2.319-.2-4.667-.052-7.047-.052z",
    transform: "translate(-60.206 -3.075)",
    style: {
      fill: "#4b4b4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29",
    d: "M62.83 31.55c.285 1.114.583 2.1.765 3.111a.966.966 0 0 1-.461.816c-4.136 1.3-8.222 1.365-12.1-.846a10.683 10.683 0 0 1 3.394-19.609 17.227 17.227 0 0 1 9.409.675l-.966 3.646c-1.48-.188-2.873-.448-4.276-.514a10.441 10.441 0 0 0-2.974.29 6.3 6.3 0 0 0-4.953 6.8 6.422 6.422 0 0 0 5.477 6.123 13.57 13.57 0 0 0 5.764-.278l.917-.217",
    transform: "translate(-8.931 -2.919)",
    style: {
      fill: "#4b4b4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 30",
    d: "m291.494 34.829.708-2.843a46.055 46.055 0 0 0 4.913.963 34.555 34.555 0 0 0 5.013-.067 2.715 2.715 0 0 0 1.308-.58 1.6 1.6 0 0 0 .068-2.762 13.526 13.526 0 0 0-2.242-1.333c-1.591-.787-3.233-1.476-4.812-2.287a14.855 14.855 0 0 1-2.514-1.627 4.941 4.941 0 0 1-1.641-5.241 4.445 4.445 0 0 1 3.465-3.413 19.456 19.456 0 0 1 8.179-.274c1.24.167 2.466.443 3.778.685l-.588 3.089c-1.229-.173-2.368-.408-3.516-.479-1.77-.108-3.55-.185-5.321-.12-1.6.058-2.434.833-2.166 1.961a2.785 2.785 0 0 0 1.145 1.546c1.169.735 2.45 1.3 3.691 1.919 1.559.78 3.142 1.514 4.682 2.329 3.748 1.987 3.02 6.989-.045 8.749a11.316 11.316 0 0 1-5.582 1.392 22.575 22.575 0 0 1-8.523-1.608",
    transform: "translate(-55.626 -2.997)",
    style: {
      fill: "#4b4b4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31",
    d: "m411.539 34.818.667-2.836a46.744 46.744 0 0 0 4.978.973 33.759 33.759 0 0 0 5.011-.084 2.725 2.725 0 0 0 1.3-.589 1.6 1.6 0 0 0 .091-2.7 13.571 13.571 0 0 0-2.321-1.382c-1.677-.832-3.4-1.566-5.067-2.421a13.474 13.474 0 0 1-2.327-1.558 4.935 4.935 0 0 1-1.58-5.086 4.384 4.384 0 0 1 3.4-3.472 19.235 19.235 0 0 1 8.268-.3c1.239.169 2.464.441 3.763.679-.164.943-.309 1.759-.448 2.575-.108.633-.565.485-.977.435-1.73-.211-3.456-.513-5.192-.6a14.049 14.049 0 0 0-3.648.3 1.941 1.941 0 0 0-1.286 1.2 2.3 2.3 0 0 0 .663 1.746 7.979 7.979 0 0 0 2.132 1.307c1.8.882 3.622 1.706 5.426 2.57.494.236.954.542 1.433.811 3.433 1.93 2.813 6.676.115 8.441a11.13 11.13 0 0 1-6.483 1.609 21.852 21.852 0 0 1-7.918-1.619",
    transform: "translate(-78.452 -2.997)",
    style: {
      fill: "#4b4b4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 32",
    d: "M385.528 36.149c-1.215 0-2.284.041-3.346-.028a1.145 1.145 0 0 1-.787-.587 43.129 43.129 0 0 1-1.333-3.313.942.942 0 0 0-1.049-.735c-2.231.034-4.465.037-6.7 0a.949.949 0 0 0-1.049.75c-.394 1.089-.853 2.156-1.25 3.243a.868.868 0 0 1-.986.686c-1.031-.052-2.067-.015-3.21-.015.113-.336.186-.6.292-.859l7.738-18.538c.343-.821.785-1.492 1.8-1.5a1.9 1.9 0 0 1 1.832 1.443q3.864 9.322 7.756 18.634c.1.232.169.475.29.819m-6.894-7.754-2.974-7.512-2.9 7.512z",
    transform: "translate(-69.761 -3.034)",
    style: {
      fill: "#4b4b4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 33",
    d: "M191.223 36.134h-4.091c-2.3 0-4.6.01-6.893 0a2.275 2.275 0 0 1-2.532-2.423c-.026-6-.011-11.994-.007-17.991a4.384 4.384 0 0 1 .076-.545h4.518V32.1h8.929z",
    transform: "translate(-33.987 -3.016)",
    style: {
      fill: "#4b4b4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 34",
    d: "M346.465 18.872v-3.251h17.725v3.251h-3.376c-.841 0-1.685.046-2.522-.013s-1.034.277-1.029 1.059c.029 5 .015 9.991.015 14.986v1.236H353.4v-1.057c0-5.028-.021-10.056.019-15.084.006-.891-.253-1.173-1.145-1.145-1.9.059-3.8.018-5.807.018",
    transform: "translate(-66.079 -3.104)",
    style: {
      fill: "#4b4b4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35",
    d: "M392.281 15.493c1.054 0 1.992.044 2.924-.014.761-.046.913.278.909.962-.025 4.383-.012 8.766-.012 13.149 0 .773.044 1.55-.012 2.319-.054.747.253.921.956.913 2.975-.033 5.952-.014 8.927-.014h1.127v3.383h-12.458c-1.728 0-2.406-.679-2.407-2.4V16.582c0-.315.028-.63.049-1.084",
    transform: "translate(-74.78 -3.075)",
    style: {
      fill: "#4b4b4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 36",
    d: "M29.454 39.088c-5.661.241-10.082-1.769-13.057-6.349a13.129 13.129 0 0 1-.108-14.948c2.934-4.728 7.393-6.8 13.185-6.595-7.093 2.255-11.194 6.839-11.161 14.1.032 7.171 4.21 11.595 11.14 13.8",
    transform: "translate(-2.864 -2.258)",
    style: {
      fill: "#ee3538"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2",
    transform: "translate(111.321 12.148)",
    style: {
      fill: "#4b4b4d"
    },
    d: "M0 0h4.528v20.92H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 37",
    d: "M339.565 15.5c1.1 0 2.128.015 3.158-.006.546-.011.632.289.628.735-.011 1.352 0 2.706 0 4.059v15.827h-3.784z",
    transform: "translate(-64.767 -3.079)",
    style: {
      fill: "#4b4b4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 38",
    d: "M33.3 32.957c-3.979.153-6.71-2.39-6.7-5.909a5.967 5.967 0 0 1 6.6-5.916c-2.644 1.181-4.2 3.094-4.24 5.892-.042 2.847 1.506 4.751 4.345 5.933",
    transform: "translate(-5.257 -4.141)",
    style: {
      fill: "#ee3538"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCkBirla);
export default __webpack_public_path__ + "static/media/logo-ck-birla.ec74f363c62c004ba9a16279e75965f6.svg";
export { ForwardRef as ReactComponent };